import { createContext, FC, ReactNode, useContext } from 'react';
import useTerritoryOptions, { TerritoryOption } from '@apiHooks/useTerritoryOptions';

export interface TerritoryOptionsValue {
    states: TerritoryOption[];
    metros: TerritoryOption[];
    isLoading: boolean;
}

const TerritoryOptionsContext = createContext<TerritoryOptionsValue | null>(null);

export const TerritoryOptionsProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const { states, metros, isLoading } = useTerritoryOptions();

    return (
        <TerritoryOptionsContext.Provider value={{ states, metros, isLoading }}>
            {children}
        </TerritoryOptionsContext.Provider>
    );
};

export function useHomeTerritoryOptions(): TerritoryOptionsValue {
    const ctx = useContext(TerritoryOptionsContext);
    if (ctx === null) {
        throw new Error('useHomeTerritoryOptions must be used inside TerritoryOptionsProvider');
    }
    return ctx;
}
